import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

const root = ReactDOM.render(<App />, document.getElementById('root'));
